module.exports = __webpack_public_path__ + "img/d855871.png";